"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _method = _interopRequireDefault(require("./create/method"));

var _param = _interopRequireDefault(require("./create/param"));

// Copyright 2017-2019 @polkadot/jsonrpc authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
// NOTE Order here is the same as in the Rust code
const call = {
  description: 'Perform a call to a builtin on the chain',
  params: [(0, _param.default)('method', 'Text'), (0, _param.default)('data', 'Bytes'), (0, _param.default)('block', 'Hash', {
    isOptional: true
  })],
  type: 'Bytes'
};
const getStorage = {
  description: 'Retrieves the storage for a key',
  params: [(0, _param.default)('key', 'StorageKey'), (0, _param.default)('block', 'Hash', {
    isOptional: true
  })],
  type: 'StorageData'
};
const getStorageHash = {
  description: 'Retrieves the storage hash',
  params: [(0, _param.default)('key', 'StorageKey'), (0, _param.default)('block', 'Hash', {
    isOptional: true
  })],
  type: 'Hash'
};
const getStorageSize = {
  description: 'Retrieves the storage size',
  params: [(0, _param.default)('key', 'StorageKey'), (0, _param.default)('block', 'Hash', {
    isOptional: true
  })],
  type: 'u64'
};
const getMetadata = {
  description: 'Returns the runtime metadata',
  params: [(0, _param.default)('block', 'Hash', {
    isOptional: true
  })],
  type: 'Metadata'
};
const getRuntimeVersion = {
  description: 'Get the runtime version',
  params: [(0, _param.default)('hash', 'Hash', {
    isOptional: true
  })],
  type: 'RuntimeVersion'
};
const queryStorage = {
  description: 'Query historical storage entries (by key) starting from a start block',
  params: [// @ts-ignore The Vec<> wrap is fine
  (0, _param.default)('keys', 'Vec<StorageKey>'), (0, _param.default)('startBlock', 'Hash'), (0, _param.default)('block', 'Hash', {
    isOptional: true
  })],
  // @ts-ignore The Vec<> wrap is fine
  type: 'Vec<StorageChangeSet>'
};
const subscribeStorage = {
  description: 'Subscribes to storage changes for the provided keys',
  params: [// @ts-ignore The Vec<> wrap is fine
  (0, _param.default)('keys', 'Vec<StorageKey>')],
  pubsub: ['storage', 'subscribeStorage', 'unsubscribeStorage'],
  type: 'StorageChangeSet'
};
const section = 'state';
/**
 * @summary Query the state and state storage.
 */

var _default = {
  isDeprecated: false,
  isHidden: false,
  description: 'Query of state',
  section,
  methods: {
    call: (0, _method.default)(section, 'call', call),
    getMetadata: (0, _method.default)(section, 'getMetadata', getMetadata),
    getRuntimeVersion: (0, _method.default)(section, 'getRuntimeVersion', getRuntimeVersion),
    getStorage: (0, _method.default)(section, 'getStorage', getStorage),
    getStorageHash: (0, _method.default)(section, 'getStorageHash', getStorageHash),
    getStorageSize: (0, _method.default)(section, 'getStorageSize', getStorageSize),
    queryStorage: (0, _method.default)(section, 'queryStorage', queryStorage),
    subscribeStorage: (0, _method.default)(section, 'subscribeStorage', subscribeStorage)
  }
};
exports.default = _default;